const Paused = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path d="M3.417 3.417h9.166v9.166H3.416V3.417Zm2 2v5.166h5.166V5.417H5.416Z" />
    </svg>
);

export default Paused;
